<div class="banner-area">
  <img [ngClass]="classNameImg" [style]="'object-position:' + positionX"  [src]="'assets/img/banners/' + img" alt="">
  <div [ngClass]="className" class="container">
    <div class="text-area">
      <h1 [ngClass]="(shouldChangeTheDirectionOfTheAnimation) ? 'slide-from-right-fade' : 'slide-from-left-fade'">{{title}}</h1>
      <p [ngClass]="(shouldChangeTheDirectionOfTheAnimation) ? 'slide-from-right-fade' : 'slide-from-left-fade'">
        {{description}}
      </p>
      <div [ngClass]="(shouldChangeTheDirectionOfTheAnimation) ? 'slide-from-right-fade' : 'slide-from-left-fade'" *ngIf="url"><a [ngClass]="'btn btn-primary '+(event)" [href]="url">{{cta}}</a></div>
      <img *ngIf="familyShow" class="family" src="assets/img/maquinas/mockups-maquininhas-azulzinha.png" alt="">
      <app-lottie-component [variantClass]="variantClass" [path]="'/assets/animations/animation3.json'"></app-lottie-component>
    </div>
  </div>
</div>

